import { FixedPriceMutationDto, FixedPriceOverviewDto } from '../registrationConfig'

export const mapFixedPriceOverviewDtoToMutation = (dto: FixedPriceOverviewDto): FixedPriceMutationDto => ({
    userId: dto.user?.id,
    type: dto.type,
    vatType: dto.vatType,
    name: dto.name || undefined,
    description: dto.description || undefined,
    longDescription: dto.longDescription || undefined,
    date: dto.date,
    rate: dto.rate?.amount,
    currency: dto.rate?.currency,
    fileId: dto.file?.id,
})
